import {
  ALLOCATION_COLORS,
  BENCHMARK_COLOR,
  PORTFOLIO_COLOR,
  useReferenceData,
} from "@iliotech/data-wire";

// Reusing the same icons from RiskVsReturnTable
const DiamondIcon = ({ color }: { color: string }) => (
  <svg width="20" height="20" viewBox="0 0 24 24">
    <path d="M12 2L22 12L12 22L2 12L12 2Z" fill={color} />
  </svg>
);

const CircleIcon = ({ color }: { color: string }) => (
  <svg width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="8" fill={color} />
  </svg>
);

interface LegendItem {
  label: string;
  color: string;
}

interface RiskVsReturnScatterLegendProps {
  items: LegendItem[];
  isHalfWidth?: boolean;
}

const RiskVsReturnScatterLegend = ({
  items,
  isHalfWidth,
}: RiskVsReturnScatterLegendProps) => {
  const { getAssetLabel } = useReferenceData();

  const stringLimit = isHalfWidth && items.length > 6 ? 5 : 22;
  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
      {items.map((item) => {
        const isBenchmark = item.label === "Benchmark";
        const isPortfolio = item.label === "Portfolio";
        const color = item.color;

        return (
          <div
            key={item.label}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 20,
                height: 20,
              }}
            >
              {isBenchmark ? (
                <DiamondIcon color={color} />
              ) : (
                <CircleIcon color={color} />
              )}
            </span>
            <span style={{ fontSize: 12 }}>
              {item.label.length > stringLimit
                ? item.label.substr(0, stringLimit) + "..."
                : item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default RiskVsReturnScatterLegend;
